import { acquireToken } from '@ms/yammer-web-authenticators';

import { getResourcesOrScopes } from '../getResourcesOrScopes';
import type { ApiHeaders, ApiMiddleware, ApiRequest } from '../types';

const headersWithAuthorization = async (request: ApiRequest): Promise<ApiHeaders | undefined> => {
  const resourcesOrScopes = getResourcesOrScopes(request);
  const token = await acquireToken({ scopes: resourcesOrScopes });

  return {
    ...request.headers,
    authorization: `Bearer ${token}`,
  };
};

export const middleware: ApiMiddleware = async (request) => ({
  ...request,
  headers: await headersWithAuthorization(request),
});
